import { cn } from '@lyearn/style';
import { getCSSVariableValue } from '@lyearn/style';

import { dismissPillBackgroundStyles } from './styles';
import { DismissPillAppearance, DismissPillSize } from './types';

const DISMISS_PILL_ICON_SIZE = {
  large: 'h-16 w-16',
  medium: 'h-14 w-14',
};

const DISMISS_PILL_ICON_COLOR = {
  blue: 'text-icon-accent',
  cyan: 'text-icon-cyan',
  danger: 'text-icon-error',
  inverse: 'text-icon-white',
  pink: 'text-icon-pink',
  primary: 'text-icon-primary',
  purple: 'text-icon-purple',
  secondary: 'text-icon-secondary',
  success: 'text-icon-success',
  warning: 'text-icon-warning',
};

export const DIMISS_PILL_BACKGROUND = {
  blue: '--icon-accent',
  cyan: '--icon-cyan',
  danger: '--icon-error',
  inverse: '--disabled-light',
  pink: '--icon-pink',
  primary: '--icon-primary',
  purple: '--icon-purple',
  secondary: '--icon-secondary',
  success: '--icon-success',
  warning: '--icon-warning',
};

export const getDissmissPillClasses = (
  size: DismissPillSize,
  appearance: DismissPillAppearance,
) => {
  const iconSize = DISMISS_PILL_ICON_SIZE[size];
  const iconColor = DISMISS_PILL_ICON_COLOR[appearance];
  const dismissIconVariableName = DIMISS_PILL_BACKGROUND[appearance];
  const colorCode = getCSSVariableValue(dismissIconVariableName, document.documentElement);

  return {
    icon: cn(iconSize, iconColor),
    root: cn('shrink-0 p-1', colorCode ? dismissPillBackgroundStyles(colorCode, appearance) : ''),
  };
};
